/**
 * /frontend/src/features/analytics/components/shared/LoadingSkeleton.js
 */

import React from 'react';
import './LoadingSkeleton.css';

/**
 * Simple loading skeleton placeholder.
 * @returns {JSX.Element}
 */
const LoadingSkeleton = () => (
  <div className="analytics-loading" aria-busy="true" aria-label="Loading">
    <div className="analytics-loading-bar" />
  </div>
);

export default LoadingSkeleton;

